import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import Counselling1 from '../img/Counseling.jpeg'; // Image for Counseling

const Counselling = () => {
    const cardData = [
        {
            id: 1,
            title: 'Anxiety counseling',
            text: 'Anxiety counseling is highly beneficial as it provides a safe space to explore these feelings and develop strategies to manage them. Through techniques such as cognitive-behavioral therapy, mindfulness, and relaxation exercises, individuals can learn to identify and change negative thought patterns, reduce physical symptoms, and cope more effectively with stress.',
        },
        {
            id: 2,
            title: 'Relational counselling',
            text: 'Relational counselling focuses on improving the dynamics and communication within relationships, whether they are romantic, familial, or platonic. It is highly beneficial as it provides a safe and neutral environment for individuals to express their feelings and concerns. Techniques such as active listening and conflict resolution are used to foster better understanding and stronger bonds.',
        },
        {
            id: 3,
            title: 'Depression counseling',
            text: 'Depression counseling is a form of therapy designed to help individuals understand, manage, and overcome depression. Depression is a mental health condition characterized by persistent feelings of sadness, and a lack of interest in daily activities. Counseling for depression provides a supportive environment where individuals can explore their thoughts, emotions.',
        },
        {
            id: 4,
            title: 'Family counseling',
            text: 'Family counseling, also known as family therapy, is a form of therapy that focuses on improving communication and resolving conflicts within a family unit. It involves working with family members to address issues that affect the overall health and functioning of the family. This type of counseling is highly beneficial as it provides a safe space for family members to express their feelings.',
        },
        {
            id: 5,
            title: 'Personality counseling',
            text: 'Personality counseling focuses on helping individuals understand their unique personality traits, strengths, and areas for growth. It involves exploring how these traits influence thoughts, behaviors, and interactions with others. This type of counseling is beneficial as it promotes greater self-awareness, helping individuals recognize their patterns and make positive changes.',
        },
        {
            id: 6,
            title: 'Career and Guidance counseling',
            text: 'Career guidance involves providing individuals with information, advice, and support to help them make informed decisions about their career paths. It includes assessing their skills, interests, and values to match them with suitable career options. This process aims to empower individuals by equipping them with the necessary knowledge and tools to navigate educational and professional opportunities effectively.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>Psychotherapy and Counseling Services | Anxiety, Depression, Relational Counseling</title>
                <meta name="description" content="Explore a variety of counseling services including anxiety, depression, family, relational, and career counseling. Get professional support for emotional well-being and personal growth." />
                <meta name="keywords" content="Psychotherapy, Counseling, Anxiety Counseling, Depression Counseling, Family Counseling, Relational Counseling, Personality Counseling, Career Counseling" />
                <meta name="author" content="Your Company Name" />
                <meta property="og:title" content="Psychotherapy and Counseling Services | Anxiety, Depression, Relational Counseling" />
                <meta property="og:description" content="Get expert counseling for anxiety, depression, family issues, and more. Learn how psychotherapy can improve mental health, relationships, and personal growth." />
                <meta property="og:image" content={Counselling1} />
                <meta property="og:url" content="https://yourwebsite.com/counseling" />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <img src={Counselling1} alt="Psychotherapy and Counseling" className='img-fluid h-100 w-100 rounded-md'/>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <h1 style={{fontFamily:'monospace'}} className='mb-4'>Psychotherapy and Counseling</h1>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Psychotherapy and counseling are vital tools for individuals seeking emotional support, personal growth, and healing. These therapeutic approaches offer a safe, confidential space where individuals can explore their thoughts, emotions, and behaviors with the guidance of trained professionals.</p>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Whether facing mental health challenges, life transitions, or the effects of past trauma, psychotherapy and counseling provide an opportunity for individuals to gain clarity, develop coping strategies, and foster a deeper understanding of themselves.</p>
                    </Col>
                </Row>
            </Container>

            <Container className='mb-5'>
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className='bg-info-subtle'>
                                <Card.Body>
                                    <Card.Title style={{color:'#093c60'}} className='fw-bold'>{card.title}</Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Counselling;
